import { h, Component } from 'preact';
import { Link } from 'preact-router';
import style from './style';

export default class Header extends Component {
	render() {
		return (
			<header class={style.header}>
				<h1>Peinn Mor Pottery</h1>
				<nav>
					<Link href="/">Gallery</Link>
					{/* <Link href="/about">About</Link> */}
					{/* <Link href="/gallery/">Gallery</Link> */}
				</nav>
			</header>
		);
	}
}



// WEBPACK FOOTER //
// ./components/header/index.js